import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { TailSpin } from 'react-loader-spinner';

import { ProsperPage } from './ProsperPage';

export const ProsperPageContainer = () => {
  const contentCategories = useAppSelector((state) => state.contentCategory.contentCategories);
  const contentCompetencies = useAppSelector(
    (state) => state.contentCompetency.contentCompetencies,
  );
  const competencyProficiencies = useAppSelector(
    (state) => state.user.user?.competency_proficiencies,
  );

  const isLoading = !contentCategories || !contentCompetencies;

  if (isLoading) {
    return (
      <Box sx={loadingSpinnerStyle}>
        <TailSpin color="#000" height={50} width={50} />
      </Box>
    );
  }

  return (
    <ProsperPage
      contentCategories={contentCategories}
      contentCompetencies={contentCompetencies}
      competencyProficiencies={competencyProficiencies ?? []}
    />
  );
};

const loadingSpinnerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  overflowY: 'scroll',
};
